import Store from 'app/redux/store'
import { bindActions } from 'redux-zero/utils'
import Source from 'app/interface/data/funnel/source'
import { NestAPI } from '../../../../nestapi'

const Dataset = bindActions(
  () => ({
    load: async () => {
      Dataset.update([], null)
      const result: Source[] = await NestAPI.get('businesses/manage/describe')
      Dataset.update(result, null)
    },

    loadBusiness: async (state: any, id: number) => {
      Dataset.update([], Number(id))
      const result: Source[] = await NestAPI.get(`businesses/manage/describe`, {
        params: { business_id: id },
      })
      Dataset.update(result, Number(id))
    },

    update: (state: any, sources: any[], businessID: number | null = null) => ({
      data: {
        ...state.data,
        funnel: {
          ...state.data.funnel,
          sources: {
            data: sources,
            businessID,
            loading: false,
            timestamp: +new Date(),
          },
        },
      },
    }),
  }),
  Store
)

export default Dataset
